export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10907.4cb6c0cb.jpg";